AngularService = App.loadClass 'core::Angular/Service'

class exports.CustomersService extends AngularService
    constructor: (@http) ->
        return

    getPrograms: (filters) ->
        return @http.post 'backend/portal/customers/get-programs',
            filters: filters
        .then (response) -> response.data.data

    getSusCustomers: () ->
        return @http.get 'backend/portal/customers/get-sus-customers'
        .then (response) -> response.data

    generatePDF: (url, year, crop, program) ->
        return @http.get url, {
            params: { year, crop, program }
        }
        .then (response) -> response.data